import React from 'react';

const Footer = () => {
    return (
        <footer className="w-full py-10 mt-10 relative z-10 flex justify-center">
            <img
                src=""
                alt="Footer"
                className="w-[80%] h-auto opacity-90 hover:opacity-100 transition-opacity duration-500"
                onError={(e) => {
                    // Si la imagen no existe en esa ruta específica, podrías avisar o usar un fallback
                    console.error("Footer image not found");
                }}
            />
        </footer>
    );
};

export default Footer;
